module.exports = __webpack_public_path__ + "static/img/logo-sw.6bad176e.png";